// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Play = function Play(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.375 16.876 15.625 10 4.375 3.126zM3.457 1.489a1.88 1.88 0 0 1 1.895.035L16.602 8.4a1.876 1.876 0 0 1 0 3.203l-11.25 6.875a1.87 1.87 0 0 1-1.895.036 1.88 1.88 0 0 1-.957-1.637V3.126c0-.68.367-1.305.957-1.637"
  }));
};
